<template>
  <div>
    <modal-provider
      name="city-location-modal"
      :title="$t('delivery-store-balance.modal-title')"
      :width="600"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      classList=""
    >
      <div ref="modal" class="modal city-location" tabindex="0">
        <div class="city-location__text">{{ $t('delivery-store-balance.modal-text') }}</div>
        <div class="zip-city__field">
          <div class="control-box">
            <vSelect
              id="zip-city"
              class="select__select select__select--select"
              :placeholder="$t('checkout_delivery_choice')"
              label="name"
              :options="computedCities"
              :value="computedCityValue"
              @search="handleSearchCity"
              @input="handleSelectCity"
              :clearable="false"
              :searchable="true"
              :filterable="false"
              :selectable="(option) => option.type !== 'divider'"
            >
              <span slot="no-options">{{ emptyError }}</span>
              <template #option="option">
                <div v-if="option.type === 'divider'" class="option-divider">
                  <span>{{ option.name }}</span>
                </div>
                <div v-else>{{ option.name }}</div>
              </template>
            </vSelect>
          </div>
        </div>
        <div class="city-location__cities">
          <button class="city-location__city"
                  :class="{ 'city-location__city--selected': userCity && item.id === userCity.id }"
                  @click="chooseCity(item)"
                  v-for="item in allCities"
                  :key="item.id"
          >
            {{ item.original_name }}
          </button>
        </div>
        <div class="city-location__info" v-html="$t('delivery-store-balance.modal-attention')"></div>
        <Loader :is-loading="isLoading" />
      </div>
    </modal-provider>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import vSelect from 'vue-select'
import Loader from '@/components/helpers/Loader.vue'
import { debounce } from '@/mixins'
// import cookieHelper from '@/helpers/cookieHelper'

export default {
  name: 'CityLocationModal',
  components: { Loader, vSelect },
  data: function () {
    return {
      title: '',
      emptyError: '',
      isLoading: false,
      sentOnClose: false
    }
  },
  mixins: [debounce],
  methods: {
    ...mapActions(['SET_USER_CITY', 'SEARCH_CITIES', 'SET_DELIVERY_CITY', 'GET_STORES_IN_CITY']),
    chooseCity (city) {
      this.isLoading = true
      this.SET_USER_CITY(city).then(() => {
        window.location.reload()
      })
    },
    beforeClose () {
      if (this.allCities.length > 0 && !this.sentOnClose && (!this.userCity || !this.userCity.id || !this.userCity?.is_selected)) {
        this.sentOnClose = true
        this.SET_USER_CITY(this.allCities[0])
      }
    },
    hideModal () {
      this.$modal.hide('result-modal')
    },
    beforeOpen ({ params }) {
      // this.type = params?.type || 'success'
      // this.title = params?.title || ''
      // this.subtitle = params?.subtitle || ''
      // this.btnText = params?.btnText || ''
    },
    handleSelectCity (val) {
      this.SET_DELIVERY_CITY(val)
      this.chooseCity(val)
    },
    handleSearchCity (val, loading) {
      this.debounce(() => {
        if (val.length >= 2) {
          let params = {}
          params.string = val
          this.emptyError = this.$t('search_in_process')
          this.SEARCH_CITIES({ params, loading }).then((res) => {
            if (Array.isArray(res) && res.length === 0) {
              this.emptyError = this.$t('not_found')
            }
            if (Array.isArray(res) && res.length > 0) {
              this.emptyError = ''
            }
          }).catch(() => {
            this.emptyError = this.$t('not_found')
          })
        } else {
          this.emptyError = this.$t('more_than_1_letter')
        }
      }, 500)
    }
  },
  computed: {
    ...mapState({
      config: state => state.init.config,
      userCity: state => state.geoLocation.userCity,
      userStore: state => state.geoLocation.userStore,
      // cities: state => state.deliveryForm.cities,
      deliveryCity: state => state.deliveryForm.deliveryCity,
      citiesFromSearch: state => state.shops.cities
    }),
    allCities () {
      if (this.config?.relevantDeliveryCities?.[1]) {
        return this.config?.relevantDeliveryCities?.[1].map(el => {
          return {
            ...el,
            name: el.original_name
          }
        })
      }
      return []
    },
    latestCities () {
      if (this.config?.relevantDeliveryCities?.[0]) {
        return this.config?.relevantDeliveryCities?.[0].map(el => {
          return {
            ...el,
            name: el.original_name
          }
        })
      }
      return []
    },
    computedCityValue () {
      if (this.userCity) {
        return this.userCity
      } else if (this.latestCities.length) {
        return this.latestCities[0]
      }
      return null
    },
    computedCities () {
      return this.citiesFromSearch && this.citiesFromSearch.length > 0 ? this.citiesFromSearch.map(el => {
        return {
          ...el,
          name: el.original_name
        }
      }) : this.allCities
    }
  },
  mounted () {
    this.GET_STORES_IN_CITY()
  }
}
</script>

<style lang="sass">
.city-location
  &__info
    b
      font-weight: 500
  .v-select .vs__actions:before
    display: none
  .vs__search, .vs__search:focus
    margin-top: 0
</style>
<style lang="sass" scoped>
::v-deep .modal__title
  font-size: 18px
  line-height: 23px
.city-location
  &__info
    font-size: 14px
    line-height: 18px
    padding: 8px 15px
    border-radius: 3px
    border: 1px solid #FFC700
    background-color: #FFFAE9
  &__cities
    display: flex
    flex-wrap: wrap
    margin: 0 -7.5px
  &__city
    padding: 6px 18px
    border-radius: 30px
    margin: 0 7.5px 15px
    background-color: #fff
    border: 1px solid #CCCCCC
    &--selected
      border-color: #FF2F00
  &__text
    margin-bottom: 16px
    font-size: 14px
    line-height: 21px
  .control-box
    margin-bottom: 16px
</style>
